module.exports = __webpack_public_path__ + "static/media/kg.2dc5ce59.webp";